<template>
  <div>
    <div class="form-row">
      <div class="col-md-12">
        <label>Discount(s):</label>
      </div>
    </div>

    <!-- Blue Line -->
    <div class="form-row">
      <div class="form-group col-md-12">
        <div class="am-blue-border"></div>
      </div>
    </div>

    <!-- Discounts -->
    <div class="form-row" v-for="(discount,index) in discounts" :key="index">
      <div class="form-group col-md-5">
        <label class="w-100" v-if="index === 0">Amount</label>
        <div class="form-row">
          <div class="form-group col-md-4">
            <select class="form-control" v-model="discount.amountType" :disabled="!isEdit">
              <option v-for="discountType in discountTypes" :key="discountType.value" :value="discountType.value">{{discountType.display}}</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <input type="text" class="form-control" v-model="discount.amount" placeholder="0" @keypress="isNumber($event, discount.amount)" @change="formatNumber(discount, 'amount')" :disabled="!isEdit">
          </div>
        </div>
      </div>
      <div class="form-group col-md-3">
        <label class="w-100" v-if="index === 0">Effective Date</label>
        <input type="date" class="form-control" v-model="discount.effectiveDate" :disabled="!isEdit || discount.amount === '' || parseFloat(discount.amount) === 0">
      </div>
      <div class="form-group col-md-3">
        <label class="w-100" v-if="index === 0">Expiration Date</label>
        <input type="date" class="form-control" v-model="discount.expirationDate" :disabled="!isEdit || (discount.effectiveDate === '' || discount.amount === '' || parseFloat(discount.amount) === 0)">
        <div class="text-danger float-right" v-if="discount.id !== 0 && isExpired(discount.expirationDate)">Discount Expired</div>
      </div>
      <div class="form-group col-md-1">
        <label class="w-100" v-if="index === 0">&nbsp;</label>
        <a class="am-addon-images" title="Remove Discount" v-if="isEdit && discounts.length > 1" @click="confirmDeleteDiscount(index)"><svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="delete" title="Delete"></svg-icon></a>
        <a class="am-addon-images" title="Add Discount" v-if="isEdit && discounts.length === index+1" @click="addDiscount"><svg-icon class="am-glyphicon-medium am-glyphicon-blue" icon="add" title="Add"></svg-icon></a>
      </div>
    </div>

    <modal name="DiscountPopUp" classes="am-vue-modal" :clickToClose="false" height="auto" width="370px" :pivotY="0.5" :adaptive="true">
      <message-popup :confirmDelete="true" @CloseModal="deleteDiscounts" modal-name="DiscountPopUp" :errors="messageString" messageHeader="Confirmation"></message-popup>
    </modal>
  </div>
</template>

<script>
import moment from 'moment'
import MessagePopup from './MessagePopup'
export default {
  name: 'DiscountSection',
  data () {
    return {
      discountTypes: [
        {
          value: 'A',
          display: '$'
        },
        {
          value: 'P',
          display: '%'
        }
      ],
      messageString: 'Are you sure you want to delete this discount?',
      deleteDiscountIndex: 0
    }
  },

  props: {
    discounts: Array,
    isEdit: {
      type: Boolean,
      default: true
    },
    deleteDiscount: {
      type: Boolean,
      default: false
    }
  },

  components: {
    MessagePopup
  },

  methods: {
    addDiscount () {
      this.discounts.push({
        id: 0,
        amountType: 'A',
        amount: '0',
        effectiveDate: '',
        expirationDate: '',
        employeeId: this.$store.state.auth.user.id
      })
    },

    isNumber (event, value) {
      event = (event) || window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault()
      } else if (charCode === 46 && value.includes('.')) {
        event.preventDefault()
      } else {
        return true
      }
    },

    formatNumber (object, attribute) {
      if (object[attribute].length === 0) {
        object[attribute] = '0'
      } else {
        object[attribute] = +object[attribute]
      }
    },

    isExpired (expirationDate) {
      let expDate = moment(expirationDate, 'YYYY-MM-DD')
      let today = moment(new Date().toISOString().slice(0, 10), 'YYYY-MM-DD')
      return today.diff(expDate) > 0
    },

    deleteDiscounts () {
      this.discounts.splice(this.deleteDiscountIndex, 1)
    },

    confirmDeleteDiscount (index) {
      if (this.deleteDiscount) {
        this.deleteDiscountIndex = index
        this.$modal.show('DiscountPopUp')
      } else {
        this.discounts.splice(index, 1)
      }
    }
  },

  watch: {
    discounts: {
      handler (val) {
        this.$emit('updateDiscounts', this.discounts)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  label {
    font-weight: bold;
    display: inline-block;
    margin-bottom: 0.5rem;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid black;
  }

  .col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-9,.col-md-12 {
    padding-left: 5px;
    padding-right: 5px;
  }

  .form-row {
    margin-right: -5px;
    margin-left: -5px;
    display: flex;
    flex-wrap: wrap;
  }

  .w-100 {
    width: 100%;
  }

  .am-addon-images {
    margin-top: 5px;
    cursor: pointer;
  }

  .am-addon-images img {
    height: 22px;
  }

  .form-control{
    border-radius: 0;
  }

  .float-right {
    float: right;
  }
</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
